module.exports = __webpack_public_path__ + "img/9788925543444.8f08f73b.jpg";